import styled from 'styled-components';
import { Sized } from '@optimus-web/common';
import { getIconColor, getIconSize } from './getIconStyles';
import { IconVariant } from './types';

export const IconWrapper = styled.span<Required<Sized>>`
    font-size: 0;
    display: inline-block;
    width: ${getIconSize}px;
    height: ${getIconSize}px;
`;

interface StyledIconProps extends Required<Sized> {
    variant: IconVariant;
}

export const StyledIcon = styled.div<StyledIconProps>`
    width: ${getIconSize}px;
    height: ${getIconSize}px;
    pointer-events: none;

    path {
        fill: ${getIconColor};
    }
`;
